<h2 mat-dialog-title>Save Equity Analysis</h2>

<mat-dialog-content>
  <mat-form-field appearance="outline" style="width: 100%">
    <mat-label>Equity Name</mat-label>

    <input matInput [(ngModel)]="equityName" placeholder="Enter equity name" maxlength="100" (keyup.enter)="save()" />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>

  <button mat-raised-button color="primary" [disabled]="!equityName.trim()" (click)="save()">Save</button>
</mat-dialog-actions>
